export default __webpack_public_path__ + "static/media/el26.06d47495.svg";